<template>
  <div class="custom-multi-select">
    <Checkbox
      :indeterminate="indeterminate"
      :value="checkAll"
      @click.prevent.native="handleCheckAll"
    >
      (All)
    </Checkbox>
    <Select
      v-model="currentValue"
      :max-tag-count="1"
      multiple
      filterable
      @on-change="valueChange"
    >
      <Option
        v-for="option in options"
        :key="option.value"
        :label="option.name"
        :value="option.value"
      />
    </Select>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'CustomMultiSelect',

  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    clearable: Boolean
  },

  data () {
    return {
      currentValue: this.value
    }
  },

  computed: {
    indeterminate () {
      return Boolean(this.options.length && this.currentValue.length && this.currentValue.length !== this.options.length)
    },

    checkAll: {
      get: function () {
        return Boolean(this.options.length && this.currentValue.length && this.currentValue.length === this.options.length)
      },
      set: function (newValue) {
        newValue ? this.currentValue = this.options.map(option => option.value) : this.currentValue = []
        this.$emit('input', this.currentValue)
      }
    }
  },

  watch: {
    value (val) {
      this.currentValue = val
    }
  },

  methods: {
    /**
     * Function for the "all" checkbox
     */
    handleCheckAll () {
      this.checkAll = this.indeterminate ? false : !this.checkAll
    },

    /**
     * Debounced Event listener for checkbox value change
     * Note: Disable debouncing for now because only place needed is UE dashboard and it has apply filter button
     * And also, it may conflict with URL param cascading loading
     * @param {Array} data updated data from checkbox
     */
    valueChange: _.debounce(function (data) {
      this.currentValue = data
      this.$emit('input', data)
    }, 0)
  }
}
</script>

<style scoped>
  #custom-select {
    padding: 5px;
  }
</style>
